import {
  queryAddEditPdfTemplate,
  queryAddNewPdfTemplate,
  queryDeleteItem,
  queryEditItemPdfTemplate,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'actionPdfTemplateGenerationMapping',
  state: {
    newPdfTemplate: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,templateGenerationFormat,documentNamePattern',
    notSelectSearch: 'templateGenerationFormat',
    expand: {
      pdfTemplate: { select: 'name' },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryPdfTemplates',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewPdfTemplate({ payload }, { put }) {
      yield put({
        type: 'addPdfTemplate',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewPdfTemplate',
          payload,
        });
      }
    },

    *editItemPdfTemplate({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemPdfTemplate, payload);
        yield put({
          type: 'editPdfTemplate',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewPdfTemplate({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewPdfTemplate, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'savePdfTemplate',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditPdfTemplate({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditPdfTemplate, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'savePdfTemplate',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'savePdfTemplate',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemPdfTemplate({ view }, { put }) {
      yield put({
        type: 'showEditItemPdfTemplate',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryPdfTemplates(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addPdfTemplate(state, { payload }) {
      return {
        ...state,
        newPdfTemplate: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewPdfTemplate(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editPdfTemplate(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    savePdfTemplate(state, { payload }) {
      return {
        ...state,
        savePdfTemplate: payload,
        newPdfTemplate: false,
        selectedItem: false,
      };
    },

    showEditItemPdfTemplate(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newPdfTemplate: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
